import type { ReactElement } from 'react';

import { SecurityAnswerForm } from 'module/auth/security_question/security_answers/components/SecurityAnswerForm';

import { useDeviceHandoffAccountFlow } from '../hooks/useDeviceHandoffAccountFlow';

export const SecurityAnswerRoute = (): ReactElement => (
    <SecurityAnswerForm {...useDeviceHandoffAccountFlow().securityAnswer} />
);
